import { useContext } from 'react';
import { StripePaymentsContext } from '../context/StripePaymentsContext';

export const useStripePayments = () => {
  return useContext(StripePaymentsContext);
};
